import { usePathname, useRouter } from 'expo-router';
import { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getCheckoutIntent } from './checkoutIntent';

export function CheckoutIntentContinuation() {
  const { isAuthenticated, isLoading, currentOrganization } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const handledIntentRef = useRef<string | null>(null);

  useEffect(() => {
    if (isLoading || !isAuthenticated || !currentOrganization || pathname === '/onboarding') return;

    let active = true;
    void getCheckoutIntent()
      .then((intent) => {
        if (
          !active ||
          !intent ||
          handledIntentRef.current === intent.idempotencyKey ||
          (intent.organizationId && intent.organizationId !== currentOrganization.id)
        ) {
          return;
        }

        handledIntentRef.current = intent.idempotencyKey;
        if (pathname !== '/settings') {
          router.replace({ pathname: '/settings', params: { section: 'billing' } });
        }
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, [currentOrganization, isAuthenticated, isLoading, pathname, router]);

  return null;
}
